import React from 'react'
import { Field } from 'react-final-form'

import Select from '@cinch/oxd-components/field-select/src'
import { Text, TextStyles } from '@cinch-labs/design-system'
import { required } from '@cinch/oxd-utils/validators/src'
import { getDateOptions, metresToMiles } from '../../utils/scheduler-utils'
import { formNames, Site, SiteDate } from '../booking-form/booking-form.component'
import ButtonGroup from '../button-group'

import * as styles from './date-fields.module.css'

const getOptions = (sites: Site[]) => sites.map(({ siteId, siteName }) => ({ value: siteId, label: siteName }))

const DateFields: React.FC<{
  i18n: {
    selectLabel: string
    milesAway: string
    dateLabel: string
  }
  sites: Site[]
  distance: number
  dates: SiteDate[]
  onDateSelected: () => any
}> = ({ sites, distance, dates, onDateSelected, i18n: { selectLabel = '', milesAway = '', dateLabel = '' } }) => (
  <>
    <div className={styles.site}>
      <Field
        label={selectLabel}
        name={formNames.SITE}
        render={(props) => (
          <Select
            id={formNames.SITE}
            label={selectLabel}
            options={getOptions(sites)}
            oxdClassName={styles.siteSelect}
            oxford
            {...props}
          />
        )}
        validate={required}
      />
      <Text oxford={true} className={styles.distance} type={TextStyles.body2}>
        {metresToMiles(distance)} {milesAway}
      </Text>
    </div>
    <Field
      name={formNames.DATE}
      component={ButtonGroup}
      validate={required}
      label={dateLabel}
      options={getDateOptions(dates, styles.dateDay)}
      dates={dates}
      onReselect={onDateSelected}
    />
  </>
)

export default DateFields
